/**
 * Select queries from gis and format them for search.
 */
import { GIS_SEARCH } from './constants';

const selectGisSearch = state => {
  const suggestedAddressesQueries =
    state.getSuggestedAddressesApi.queries || {};

  const suggestedAddresses = Object.keys(suggestedAddressesQueries).map(k => ({
    ...(suggestedAddressesQueries[k] || {}),
    _query: k,
    _datasetName: GIS_SEARCH,
  }));

  return {
    keys: ['_query'],
    data: suggestedAddresses,
  };
};

export default selectGisSearch;
